module.exports = __webpack_public_path__ + "static/media/flf.968e8658.png";